import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import EmptyState from "@/components/feature/EmptyState";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { useFavorites } from "@/hooks/useFavorites";
import { allMedia } from "@/lib/media";

export default function Favorites() {
  useDocumentMeta(
    "我的收藏 - 91在线观看视频",
    "查看你在91在线观看视频收藏的影视作品，随时回到想看的内容。",
    "我的收藏,影视收藏,91在线观看视频",
  );

  const { favorites, toggleFavorite } = useFavorites();
  const items = favorites
    .map((id) => allMedia.find((media) => media.id === id))
    .filter((media): media is (typeof allMedia)[number] => Boolean(media));

  return (
    <div className="mx-auto max-w-6xl px-4 py-8 md:px-8 md:py-10">
      <nav className="mb-4 flex items-center gap-1.5 text-xs text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">我的收藏</span>
      </nav>

      <h1 className="text-2xl font-black text-foreground-950 md:text-3xl">我的收藏</h1>
      <p className="mt-2 text-sm text-foreground-600">
        收藏保存在当前浏览器本地，清除浏览器数据后会被移除。共 {items.length} 部作品。
      </p>

      {items.length > 0 ? (
        <div className="mt-7 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {items.map((item) => (
            <div key={item.id} className="group/card relative">
              <MediaCard item={item} />
              <button
                type="button"
                aria-label="取消收藏"
                onClick={() => toggleFavorite(item.id)}
                className="absolute right-2 top-10 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/90 text-accent-700 opacity-0 transition-opacity hover:bg-background-50 group-hover/card:opacity-100"
              >
                <i className="ri-heart-3-fill"></i>
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-7">
          <EmptyState
            icon="ri-heart-3-line"
            title="还没有收藏任何作品"
            description="在影视详情页点击收藏按钮，就能把喜欢的内容放到这里。"
            action={
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-700"
              >
                去发现好片
              </Link>
            }
          />
        </div>
      )}
    </div>
  );
}